import { ReactNode } from 'react';
import HeaderSideBar from '../HeaderSideBar';

interface AppShellProps {
  children: ReactNode;
  backRoute?: boolean;
  className?: string;
}

export default function AppShell({ children, backRoute, className }: AppShellProps) {
  return (
    <HeaderSideBar backRoute={backRoute}>
      <div className={className || 'space-y-6'}>{children}</div>
    </HeaderSideBar>
  );
}
